import appGlobalScript from '/builds/firstspirit/frontend_ag_page/src/global/_global.tsx';
export const globalScripts = appGlobalScript;
